import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import MultiAutoCompleteField from './autocomplete/MultiAutoCompleteField';

const MultiAutoCompleteFilter = (props) => {
    const {
        input,
        label,
        minLength,
        optionValue,
        reference,
        searchBy,
        searchParams,
    } = props;

    return (
        <Field
            component={ MultiAutoCompleteField }
            fullWidth={ true }
            input={ input }
            label={ label ? label : null }
            minLength={ minLength }
            name={ input.name }
            optionText={ searchBy }
            optionValue={ optionValue }
            reference={ reference }
            searchParams={ searchParams }
            searchBy={ searchBy }
        />
    );
};

MultiAutoCompleteFilter.defaultProps = {
    minLength: 3,
    optionValue: 'id',
    searchParams: {},
};

MultiAutoCompleteFilter.propTypes = {
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onDragStart: PropTypes.func,
        value: PropTypes.value,
    }),
    label: PropTypes.string,
    minLength: PropTypes.number,
    optionValue: PropTypes.string,
    reference: PropTypes.string.isRequired,
    searchBy: PropTypes.string.isRequired,
    searchParams: PropTypes.object,
};

export default MultiAutoCompleteFilter;



// WEBPACK FOOTER //
// ./src/components/list/Filters/types/MultiAutoCompleteFilter.js